export default {
  /**
   * 分類条件の標準フォーマット
   */
  get() {
    return {
      /**
       * 説明
       */
      description: undefined,
      /**
       * 企業コード
       */
      company: undefined,
      /**
       * タイプ（フォーマット）
       */
      type: 'bizoope',
      /**
       * 集計キー
       */
      groupKeys: ['term', 'item', 'store'],
      /**
       * 追加ダウンロード
       */
      optionalDownloads: [],
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用するフォーマットに変換する
   */
  mapToApiPayload(basic) {
    return {
      description: basic.description,
      company: basic.company,
      type: basic.type,
      groupKeys: basic.groupKeys,
      optionalDownloads: basic.optionalDownloads,
    }
  },
  /**
   * basic
   */
  applyPayload(applyTo, basic) {
    applyTo.description = basic.description
    applyTo.company = basic.company
    applyTo.type = basic.type || 'bizoope'
    applyTo.groupKeys = basic.groupKeys || ['term', 'item', 'store']
    applyTo.optionalDownloads = basic.optionalDownloads
  },
}
